module.exports = __webpack_public_path__ + "img/OT003.4c2f5a0.jpg";